module.exports = __webpack_public_path__ + "static/footer-shape-94641098823504af907bd51e1ebafd62.png";